import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Menu, X } from "lucide-react";
import { NAV_LINKS } from "../data/site";

export const Nav = ({ lenis }) => {
    const [open, setOpen] = useState(false);

    const go = (e, href) => {
        e.preventDefault();
        setOpen(false);
        if (lenis) lenis.scrollTo(href, { offset: -64, duration: 1.4 });
        else document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
    };

    return (
        <>
            <header
                data-testid="site-nav"
                className="fixed inset-x-0 top-0 z-50 border-b border-white/10 bg-black/70 backdrop-blur-xl"
            >
                <div className="mx-auto flex h-16 max-w-screen-2xl items-center justify-between px-6 md:px-12">
                    <a
                        href="#home"
                        data-testid="nav-logo"
                        onClick={(e) => go(e, "#home")}
                        className="flex items-center gap-3"
                    >
                        <img
                            src="/logo.png"
                            alt="SVS Balaji Industries logo"
                            data-testid="nav-logo-img"
                            className="h-9 w-9 rounded-full"
                        />
                        <span className="flex items-baseline gap-2">
                            <span className="font-display text-xl uppercase tracking-tight text-zinc-100">
                                SVS <span className="text-ember">Balaji</span>
                            </span>
                            <span className="font-mono text-[11px] font-semibold uppercase tracking-[0.3em] text-zinc-100">
                                Industries
                            </span>
                        </span>
                    </a>
                    <nav className="hidden items-center gap-8 lg:flex">
                        {NAV_LINKS.map((l) => (
                            <a
                                key={l.href}
                                href={l.href}
                                data-testid={`nav-link-${l.label.toLowerCase()}`}
                                onClick={(e) => go(e, l.href)}
                                className="font-mono text-[11px] uppercase tracking-[0.2em] text-zinc-400 transition-colors hover:text-ember"
                            >
                                {l.label}
                            </a>
                        ))}
                    </nav>
                    <div className="flex items-center gap-3">
                        <a
                            href="#contact"
                            data-testid="nav-quote-btn"
                            onClick={(e) => go(e, "#contact")}
                            className="hidden border border-ember/60 px-5 py-2.5 font-mono text-[11px] uppercase tracking-[0.2em] text-zinc-100 transition-colors hover:bg-ember hover:text-white sm:block"
                        >
                            Get a Quote
                        </a>
                        <button
                            data-testid="nav-menu-btn"
                            onClick={() => setOpen(!open)}
                            aria-label="Toggle menu"
                            className="text-zinc-200 lg:hidden"
                        >
                            {open ? <X size={22} /> : <Menu size={22} />}
                        </button>
                    </div>
                </div>
            </header>
            <AnimatePresence>
                {open && (
                    <motion.div
                        data-testid="mobile-menu"
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        className="fixed inset-0 z-40 bg-black/95 backdrop-blur-2xl lg:hidden"
                    >
                        <div className="flex h-full flex-col items-start justify-center gap-6 px-10">
                            {NAV_LINKS.map(
                                (l, i) => (
                                    <motion.a
                                        key={l.href}
                                        href={l.href}
                                        initial={{ opacity: 0, x: -24 }}
                                        animate={{ opacity: 1, x: 0 }}
                                        transition={{ delay: 0.08 * i }}
                                        data-testid={`mobile-nav-${l.label.toLowerCase()}`}
                                        onClick={(e) => go(e, l.href)}
                                        className="font-display text-4xl uppercase text-zinc-200 transition-colors hover:text-ember"
                                    >
                                        {l.label}
                                    </motion.a>
                                ),
                            )}
                        </div>
                    </motion.div>
                )}
            </AnimatePresence>
        </>
    );
};
